import init from '../../../js/init';

const name = 'modal';
const selector = '.modal';
const modalContentSelector = `${selector}__content`;
const modalCloseSelector = `${selector}__close`;
const visibleModalClass = `${selector}--visible`.substring(1);
const fadeModalClass = `${selector}--fade`.substring(1);

const ANIMATION_DURATION = 300;

/**
 * Class that handles modal functionality.
 */
export class Modal {
  constructor(modalElem) {
    this.modalElem = modalElem;
    this.contentElem = modalElem.querySelector(modalContentSelector);
    this.modalElem.onclick = () => this.onModalClick();
    this.listenToEvents();
  }

  /**
   * Opens modal.
   * Prevents body from scrolling.
   * Adds Escape listener.
   */
  open() {
    this.modalElem.classList.add(visibleModalClass);

    setTimeout(
      () =>
        requestAnimationFrame(() => {
          this.modalElem.classList.add(fadeModalClass);
          document.body.style.overflow = 'hidden';
          this.addEscListener();
        }),
      100
    );
  }

  /**
   * Closes modal and destroys it.
   * Allows body to scroll.
   * Removes Escape listener.
   */
  close() {
    this.modalElem.classList.remove(fadeModalClass);
    document.body.style.overflow = '';

    setTimeout(() => {
      this.modalElem.classList.remove(visibleModalClass);
    }, ANIMATION_DURATION);

    this.removeEscListener();
    history.pushState({}, '', window.location.origin + window.location.pathname);
  }

  /**
   * Close modal if content is not hovered.
   * This closes modal both on close button and overlay background click.
   */
  onModalClick() {
    if (
      !this.contentElem.matches(':hover') ||
      this.contentElem.querySelector(`${modalCloseSelector}:hover`)
    )
      this.close();
  }

  /**
   * Listen to keyboard to detect Escape.
   */
  addEscListener() {
    this.onKeyUp = this.onKeyUp.bind(this);

    document.addEventListener('keyup', this.onKeyUp);
  }

  /**
   * Removes keyboard listener.
   */
  removeEscListener() {
    document.removeEventListener('keyup', this.onKeyUp);
  }

  /**
   * Check if Escape is pressed and closes the modal.
   * @param {Event} e - Event object
   */
  onKeyUp(e) {
    if (e.key === 'Escape') this.close();
  }

  listenToEvents() {
    this.modalElem.addEventListener('open', () => this.open());
    this.modalElem.addEventListener('close', () => this.close());
  }
}

init(Drupal, name, selector, root => {
  new Modal(root);
});
